import classes from "./SearchForm.module.css";

export function SearchTypeSwitch({ current, types, onSelect }) {
  return (
    <div className={classes.searchTypeSwitch}>
      {types.map((t) => (
        <button
          onClick={() => onSelect(t.name)}
          className={t.name === current ? classes.active : ""}
          data-type={t.name}
          key={t.name}>
          {t.icon && <t.icon size={20} stroke={1.75} />}
          {t.label}
        </button>
      ))}
    </div>
  );
}
